type IconProps = React.HTMLAttributes<SVGElement>;

export const ChevronUp = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7071 7.20711C12.0676 6.84662 12.0953 6.27939 11.7903 5.8871L11.7071 5.79289L6.70711 0.792893C6.34662 0.432409 5.77939 0.404679 5.3871 0.709704L5.29289 0.792893L0.292894 5.79289C-0.0976304 6.18342 -0.0976304 6.81658 0.292893 7.20711C0.653378 7.56759 1.22061 7.59532 1.6129 7.29029L1.70711 7.20711L6 2.915L10.2929 7.20711C10.6534 7.56759 11.2206 7.59532 11.6129 7.2903L11.7071 7.20711Z"
      fill="currentColor"
    />
  </svg>
);
